// API Client - Main entry point for all API calls
//
// This is the public interface that all application code imports.
// It delegates to the authInterceptor which wraps the httpClient
// with authentication logic (token refresh, 401 retries, etc).
//
// Usage throughout the app:
//   import apiClient from '@services/api/apiClient';
//   await apiClient.get('/some/endpoint');
//   await apiClient.post('/auth/login', data);

import authInterceptor from '../auth/authInterceptor';

/**
 * apiClient - The main export that everyone imports
 * 
 * This delegates to authInterceptor which handles:
 * - Proactive token refresh
 * - Automatic retry on 401 errors
 * - Smart handling of auth vs non-auth endpoints
 */
const apiClient = authInterceptor;

// Convenience methods
apiClient.get = (endpoint, options = {}) => {
  return apiClient(endpoint, { ...options, method: 'GET' });
};

apiClient.post = (endpoint, data, options = {}) => {
  return apiClient(endpoint, {
    ...options,
    method: 'POST',
    body: JSON.stringify(data),
  });
};

apiClient.put = (endpoint, data, options = {}) => {
  return apiClient(endpoint, {
    ...options,
    method: 'PUT',
    body: JSON.stringify(data),
  });
};

apiClient.patch = (endpoint, data, options = {}) => {
  return apiClient(endpoint, {
    ...options,
    method: 'PATCH',
    body: JSON.stringify(data),
  });
};

apiClient.delete = (endpoint, options = {}) => {
  return apiClient(endpoint, { ...options, method: 'DELETE' });
};

export default apiClient;

